export const getAssociationClubsMapping = (state: {
  association: { players: { common: { associationClubsMapping: any } } };
}) => state.association.players.common.associationClubsMapping;

export const getAssociationPlayersMapping = (state: {
  association: { players: { common: { associationPlayersMapping: any } } };
}) => state.association.players.common.associationPlayersMapping;
